import { cn } from "../../lib/cn";

interface SpinnerProps extends React.SVGAttributes<SVGSVGElement> {
  size?: number | string;
}

/** Indeterminate rotating circle. Honours `currentColor` so the caller
 *  controls the hue through text color utilities. */
export function Spinner({ size = 16, className, ...rest }: SpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      role="presentation"
      className={cn("inline-block", className)}
      {...rest}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeOpacity="0.25"
        strokeWidth="2.5"
      />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 12 12"
          to="360 12 12"
          dur="0.9s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
}
